import { render, staticRenderFns } from "./SystemRoleSettings.vue?vue&type=template&id=1706e07c&scoped=true"
import script from "./SystemRoleSettings.vue?vue&type=script&lang=js"
export * from "./SystemRoleSettings.vue?vue&type=script&lang=js"
import style0 from "./SystemRoleSettings.vue?vue&type=style&index=0&id=1706e07c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1706e07c",
  null
  
)

export default component.exports